var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-upload-box"},[_c('el-upload',{ref:"upload",attrs:{"downloadUrl":_vm.downloadUrl,"url":_vm.url},on:{"handleSuccess":_vm.handleSuccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }